import React from 'react';

export const { Consumer, Provider } = React.createContext({
  filter: {},
  setFilter: () => {}
});

export const withFilterOption = ComponentToWrap => {
  return props => (
    <Consumer>
      {({ filter, setFilterValues }) =>
        <ComponentToWrap {...props} filter={filter} setFilterValues={setFilterValues} />
      }
    </Consumer>
  );
};



// WEBPACK FOOTER //
// ./src/client/js/view/data-providers/filter.js